module.exports = __webpack_public_path__ + "static/img/duom044.123ec86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/duom044.png
// module id = 991
// module chunks = 0